module.exports = __webpack_public_path__ + "img/jackpot-instant-prize.28e744a0.svg";